import {ApiDelete, ApiGetRaw, ApiPatch, ApiPostRaw} from "../../../shared/services/api-service";
import calendarCommitTypes from "./commit-types";

export default {
  fetchEventsForDateRange(userId, startDate, endDate) {
    return (dispatch) => {
      return ApiGetRaw(`/api/v1/events?userId=${userId}&from=${startDate}&to=${endDate}`)
        .then(data => {
          dispatch({
            type: calendarCommitTypes.SET_CALENDAR_EVENTS,
            list: data
          })
        })
    }
  },

  fetchMyEventsForDateRange(startDate, endDate) {
    return (dispatch) => {
      return ApiGetRaw(`api/v1/events/my?from=${startDate}&to=${endDate}`)
        .then(data => {
          dispatch({
            type: calendarCommitTypes.SET_MY_CALENDAR_EVENTS,
            list: data
          })
        })
    }
  },

  createEvent(formData) {
    return (dispatch) => {
      return ApiPostRaw(`/api/v1/events`, {
        event: formData
      })
        .then(data => {
          dispatch({
            type: calendarCommitTypes.CREATE_EVENT,
            event: data
          })
        })
    }
  },

  updateEvent(formData) {
    return (dispatch) => {
      dispatch({
        type: calendarCommitTypes.UPDATE_EVENT,
        event: formData
      })

      return ApiPatch(`/api/v1/events/${formData.id}`, {
        event: formData
      })
        .then(data => {
        })
    }
  },
  deleteEvent(formData) {
    return (dispatch) => {
      dispatch({
        type: calendarCommitTypes.DELETE_EVENT,
        event: formData
      })

      return ApiDelete(`/api/v1/events/${formData.id}`)
        .then(data => {
        })
    }
  }
}
